export default __webpack_public_path__ + "static/media/Artboard 4.90304901.png";